import * as React from 'react';

export const PlaceAdButtonContent: React.FC = () => (
  <>
    <span className="c-header-create-add">+</span> Разместить объявление
  </>
);

PlaceAdButtonContent.displayName = 'PlaceAdButtonContent';
